(function ($) {

    'use strict';

    var ProductDetail = {
        $carousel: $('.product-carousel-inmodal'),
        init: function () {
            this.bindEvents();
        },
        bindEvents: function () {
            var self = this;
            $('[data-target=".product-carousel-modal"]').on('click', function(e) {
                var startOn = $(this).data('start-on');
                if (typeof startOn !== 'undefined') {
                    self.goTo(startOn);
                }
            });
        },
        goTo: function (startOn) {
            this.$carousel.carousel(startOn);
        }
    };
    ProductDetail.init();
}(jQuery));